// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: '.umi__plugin-layout__Layout' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/.umi/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "name": "book",
        "path": "/book",
        "routes": [
          {
            "path": "/book",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Book__Overview' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Book/Overview'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/book/:bookName",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Book__$dynamic' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Book/$dynamic'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          }
        ]
      },
      {
        "path": "/sentence",
        "routes": [
          {
            "path": "/sentence/:sentenceID",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sentence__$dynamic' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Sentence/$dynamic'), loading: LoadingComponent}),
            "exact": true
          }
        ],
        "hideInMenu": true
      },
      {
        "name": "search",
        "path": "/search",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Search' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Search'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/search",
            "redirect": "/search/content",
            "exact": true
          },
          {
            "path": "/search/content/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Search__Content' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Search/Content'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/search/book/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Search__Book' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Search/Book'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          }
        ]
      },
      {
        "name": "occurrence",
        "path": "/occurrence",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Occurrence' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Occurrence'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/occurrence",
            "redirect": "/occurrence/content",
            "exact": true
          },
          {
            "path": "/occurrence/content/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Occurrence__Content' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Occurrence/Content'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/occurrence/book/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Occurrence__Book' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Occurrence/Book'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          }
        ]
      },
      {
        "name": "reuse",
        "path": "/reuse",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Reuse' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Reuse'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "diachronicngram",
        "path": "/diachronicngram",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Diachronicngram' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Diachronicngram'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "frequency",
        "path": "/frequency",
        "routes": [
          {
            "path": "/frequency",
            "redirect": "/frequency/ngram",
            "exact": true
          },
          {
            "name": "ngram",
            "path": "/frequency/ngram",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Frequency__Ngram' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Frequency/Ngram'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "word",
            "path": "/frequency/word",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Frequency__Word' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/Frequency/Word'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "exact": true
          },
          {
            "exact": true
          }
        ]
      },
      {
        "name": "about",
        "path": "/about",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__About' */'/data/home/pku/Desktop/YuanLiu324/bigdataAnalyze/src/pages/About'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
